import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { OfficerService } from "@services";
import Modal from "../Modal/Modal";
import Switch from "../Switch/Switch";
import Image from "../Image/Image";
import ScrollDetect from "../ScrollDetect/ScrollDetect";

import "./SearchOfficerModal.scss";

let cancel;
class SearchOfficerModal extends Component {
	constructor(props) {
		super(props);
		this.initialState = {
			officers: "",
			searchResults: [],
			loading: false,
			hasMore: false,
			pageNumber: 1,
			includeNonJurisdiction: false,
			searchToggled: false,
		};

		this.state = { ...this.initialState };
	}

	componentDidUpdate({ show: prevShow }) {
		const { show } = this.props;
		if (prevShow !== show && show) {
			this.onModalRender();
		}
	}

	onModalRender = () => {
		const { user } = this.props;
		this.setState({ includeNonJurisdiction: !user.isLEA() });
	};

	toggleOwnOfficers = () => {
		const { searchToggled } = this.state;
		this.setState(
			prevState => ({
				includeNonJurisdiction: !prevState.includeNonJurisdiction,
				pageNumber: 1,
			}),
			() => {
				if (searchToggled) this.searchOfficers();
			},
		);
	};

	/**
	 * Retrieves a paginated list of officers which match the search crteria
	 */
	searchOfficers = () => {
		const { lang } = global;
		const { pageNumber, officers, includeNonJurisdiction } = this.state;
		const queryParams = { pageNumber, displayCount: 25, includeNonJurisdiction };
		if (officers === "") return;
		const searchParams = {
			firstName: officers,
			lastName: officers,
			emailAddress: officers,
			mobilePhone: "",
			zipCode: "",
		};
		if (cancel) cancel();
		this.setState({ loading: true });
		OfficerService.search(queryParams, searchParams, c => {
			cancel = c;
		})
			.then(({ data: { ItemList } }) => {
				cancel = undefined;
				this.setState(prevState => ({
					searchToggled: true,
					pageNumber: prevState.pageNumber + 1,
					searchResults:
						pageNumber === 1 ? ItemList : [...prevState.searchResults, ...ItemList],
					hasMore: ItemList.length >= 25,
				}));
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading officers"),
					timeOut: 1500,
				});
				this.setState({
					hasMore: false,
					searchToggled: false,
				});
			})
			.finally(() => {
				this.setState({ loading: false });
			});
	};

	handleInputChange = event => {
		const {
			target: { value },
		} = event;
		this.setState({ officers: value });
	};

	handleOnSearch = event => {
		event.preventDefault();
		const { officers } = this.state;
		if (officers === "") {
			this.clearSearchResults();
			return;
		}
		this.setState({ pageNumber: 1 }, () => this.searchOfficers());
	};

	clearSearchResults = () => {
		this.setState({
			searchToggled: false,
			pageNumber: 1,
			searchResults: [],
			hasMore: false,
		});
	};

	selectOfficer = id => event => {
		event.preventDefault();
		const { searchResults } = this.state;
		const { callback } = this.props;
		const officer = searchResults.find(item => item.Id === id);
		callback(officer);
		this.onClose();
	};

	onClose = () => {
		const { closeModal } = this.props;
		this.setState({ ...this.initialState }, () => closeModal());
	};

	render() {
		const { lang } = global;
		const { user, show } = this.props;
		const { searchResults, loading, hasMore, officers, includeNonJurisdiction } = this.state;
		return (
			<Modal
				id="search-officer-modal"
				show={show}
				onHide={this.onClose}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Search Officer")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row form-group v-align-sm">
						<div className="col-sm-8">
							<div className="input-group">
								<input
									id="select-officer"
									className="form-control"
									placeholder={lang.t("Search by officer name or email")}
									value={officers}
									onChange={this.handleInputChange}
									onKeyPress={e => {
										if (e.key === "Enter") this.handleOnSearch(e);
									}}
								/>
								<span className="input-group-btn">
									<button
										type="button"
										aria-label="Search Officers"
										className="btn btn-primary"
										onClick={this.handleOnSearch}
									>
										<i
											className={`glyphicon ${loading ? "glyphicon-repeat rkf-spin rkf-fw" : "glyphicon-search"}`}
										/>
									</button>
								</span>
							</div>
						</div>
						<If condition={user.isLEA()}>
							<div className="col-sm-4">
								<Switch
									label={lang.t("My Officers Only")}
									on={!includeNonJurisdiction}
									onClick={() => this.toggleOwnOfficers()}
								/>
							</div>
						</If>
					</div>
					<div className="officer-list">
						<For
							each="officer"
							of={searchResults}
						>
							<div
								key={`officer-results_${officer.Id}`}
								className="row"
							>
								<div className="col-xs-4 col-sm-2">
									<Image
										className="img-circle img-responsive"
										src={officer.ContactPhotoUrl}
										fallbackSrc="avatar"
										alt={`${officer.FirstName} ${officer.LastName}'s profile picture`}
									/>
								</div>
								<div className="col-xs-8">
									<strong className="text-capitalize">
										{officer.FirstName} {officer.LastName}
									</strong>
									<div
										className="truncate"
										title={officer.EmailAddress}
									>
										<i className="rkf rkf-email" />
										&nbsp;
										{officer.EmailAddress}
									</div>
									<If condition={officer?.MobilePhone}>
										<div>
											<i className="rkf rkf-phone" />
											&nbsp;
											{utils.formatPhoneNumber(officer.MobilePhone)}
										</div>
									</If>
									<If condition={officer?.Department}>
										<div>{`${lang.t("Jurisdiction")}: ${officer.Department}`}</div>
									</If>
									<If condition={officer?.OfficerRank}>
										<div>{`${lang.t("Rank")}: ${officer.OfficerRank}`}</div>
									</If>
								</div>
								<div className="col-xs-12 col-sm-2">
									<button
										type="button"
										className="btn btn-primary btn-block"
										onClick={this.selectOfficer(officer.Id)}
									>
										{lang.t("Select")}
									</button>
								</div>
							</div>
						</For>
						<If condition={searchResults.length === 0 && !loading}>
							<div className="text-center text-muted">
								{lang.t("No results found")}
							</div>
						</If>
						<If condition={hasMore}>
							<ScrollDetect
								className="text-center no-overflow"
								onVisible={this.searchOfficers}
							>
								<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
							</ScrollDetect>
						</If>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						id="cancel-search-contact"
						className="btn btn-link"
						onClick={this.onClose}
					>
						{lang.t("Cancel")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

SearchOfficerModal.propTypes = {
	user: PropTypes.object,
	show: PropTypes.bool,
	closeModal: PropTypes.func,
	callback: PropTypes.func,
};

SearchOfficerModal.defaultProps = {
	user: {},
	show: false,
	closeModal: () => {},
	callback: () => {},
};

export default SearchOfficerModal;
